<template>
    <div>
        <crud-facecade
            ref="documentList"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            v-wechat-title="title"
            :tableHeight="tableHeight"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            @loadEditView="loadEditView"
            @removeItem="removeItem"
        >
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="loadingNewDocuments()" title="">新增文书<i class="el-icon--right"></i></el-button>
            </slot>
        </crud-facecade>

        <!-- 设计页面 -->
        <document-edit ref="documentEdit" :dialogVisible.sync="dialogVisible" @closeDesign="closeDesign" :ReadOnly="ReadOnly" />
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DoucmentConfig`,
    props: {

    },
    data() {
        return {
            title: `移动端文书配置`,
            url: { baseURL: `/api/MobilePaper/MobilePaper` },
            Tenants: [],
            dialogVisible: false,
            ReadOnly: false,
            buttons: []
        }
    },
    created() {
    },
    computed: {
        ...mapGetters([`screenHeight`, `sys_enums`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `integer`,
                prop: `id`,
                label: `ID`,
                isKey: true
            }, {
                type: `string`,
                prop: `paper_name`,
                label: `文书名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `doc_id`,
                label: `文书编号`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                readonly: false,
                isCreatable: true
            }, {
                type: `select`,
                prop: `enum_worker_role`,
                label: `使用文书角色`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                options: [{ value: 0, label: `通用`, jianpin: `TY`, code: `` }].concat(this.sys_enums.Enum_WorkerRole) || [],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `select`,
                prop: `is_deleted`,
                label: `是否禁用`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                readonly: false,
                options: [
                    { value: 0, label: `启用` },
                    { value: 1, label: `禁用` }
                ],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `140`,
                isListable: true,
                fixed: `right`,
                readonly: false,
                options: (that, { row }) => {
                    return [
                        {
                            class: `is-plain`,
                            label: `查看`,
                            icon: ``,
                            type: `primary`,
                            emit: `loadEditView`,
                            permission: `default`
                        },
                        {
                            class: `is-plain`,
                            label: `删除`,
                            icon: ``,
                            type: `danger`,
                            emit: `removeItem`,
                            permission: `default`
                        }
                    ]
                }
            }
            ]
        }
    },
    mounted() {

    },
    methods: {
        loadEditView({ row }) {
            this.ReadOnly = false
            this.$refs[`documentEdit`].loadData(row.id, this.ReadOnly)
            this.dialogVisible = true
        },
        removeItem({ row, index }) {
            let that = this
            if (row.id && row.id > 0) {
                this.$confirm(`此操作将永久删除该记录, 是否继续?`, `提示`, {
                    confirmButtonText: `确定`,
                    cancelButtonText: `取消`,
                    type: `warning`,
                    closeOnClickModal: false
                }).then(() => {
                    let req = that.myaxios.delete(`/api/MobilePaper/MobilePaper/Delete/${row.id}`)
                    req.then(data => {
                        that.$message.success(`删除成功`)
                        that.$refs[`documentList`].ReloadListData()
                    }).catch(e => {
                        console.log(`删除失败`, e)
                    })
                })
            }
        },
        closeDesign() {
            // TODO:弹窗关闭后刷新列表
            this.$refs[`documentList`].ReloadListData()
        },
        loadingNewDocuments() {
            this.ReadOnly = false
            this.$refs[`documentEdit`].initData(this.ReadOnly)
            this.dialogVisible = true
        }

    }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DoucmentConfig/Index.vue